const Annotate = ({ width = 16, height = 17, color = '#DA291C' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6637 8.35286C14.6637 12.0329 11.6804 15.0162 8.00033 15.0162C4.32027 15.0162 1.33699 12.0329 1.33699 8.35286C1.33699 4.67281 4.32027 1.68953 8.00033 1.68953C11.6804 1.68953 14.6637 4.67281 14.6637 8.35286Z"
        stroke={color}
        strokeWidth="1.34"
        strokeLinejoin="round"
      />
      <path
        d="M7.33366 5.16569V5.80941L8.00033 6.45312L8.66699 5.80941V5.16569H7.33366Z"
        fill={color}
      />
      <path
        d="M8.66634 11.82V7.84294L7.99967 7.19922L7.33301 7.84294V11.82H8.66634Z"
        fill={color}
      />
    </svg>
  )
}

export default Annotate
